export const COLORS = {
  WHITE: '#fff',
  BUTTON_PRIMARY: '#3683CB',
  BUTTON_DISABLED: '#4c455f74',
  SECONDARY_TEXT: '#bbc6de',
};
